import { UserAuditLogEntry } from 'apis/auditLogs';

import { UserLink } from '../activityTypes/userLink/userLink';
import { CardField, UserActivityCard } from './userActivityCard';
import { humanize, statusColors } from './userActivityTypes.utils';

type AgentUnbannedUserProps = {
  entry: UserAuditLogEntry<'AGENT_UNBANNED_USER'>;
};

export const AgentUnbannedUser = ({
  entry,
}: AgentUnbannedUserProps): JSX.Element => {
  const channels = entry.channel_ref.map(humanize).join(', ');
  const fields: CardField[] = [{ label: 'Reason', value: entry.reason }].filter(
    (field) => field.value,
  );

  return (
    <UserActivityCard
      entry={entry}
      icon="check-circle"
      color={statusColors.positive}
      title="Unbanned"
      titleSuffix={
        <UserLink
          userId={entry.user_id}
          onClick={(event) => event.stopPropagation()}
        >
          {entry.user_name ?? entry.user_id}
        </UserLink>
      }
      summary={channels || undefined}
      fields={fields}
    />
  );
};
